import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Collapse, Box } from '@material-ui/core';

import Icon from 'components/Icon';
import style from './index.module.scss';

const MenuItem = ({ name, href, to, submenu, submenuMaxHeight, position }) => {
  const [isShow, setIsShow] = useState(false);
  const handlePopoverOpen = () => {
    setIsShow(true);
  };

  const handlePopoverClose = () => {
    setIsShow(false);
  };

  return (
    <li onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}>
      {href && <a href={href}>{name}</a>}
      {to && <Link to={to}>{name}</Link>}
      {!href && !to && <span>{name}</span>}
      {submenu && (
        <>
          <Icon.ArrowBreadcrumbs fontSize={16} rotate={90} />

          <Collapse
            in={isShow}
            className={`${style.submenu} ${position ? style[position] : ''}`}
          >
            <Box
              className={style.submenu_wrapper}
              sx={{ maxHeight: submenuMaxHeight || 256 }}
            >
              {submenu.map(({ Icon, ...item }) => (
                <Link key={item.id} to={item.href}>
                  <Box mr={1} width={32} display="flex" alignItems="center">
                    {Icon && <Icon fontSize={24} />}
                  </Box>

                  <span>
                    <b>{item.title}</b>
                    <span>{item.description}</span>
                  </span>
                </Link>
              ))}
            </Box>
          </Collapse>
        </>
      )}
    </li>
  );
};

export default MenuItem;
